import {Component, EventEmitter, OnInit, Output, Input, inject} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {RestUrlsConfig, GenericConfig} from '@signature-it/ngx-generic/config';
import {PageNotificationService, LanguageService } from '@signature-it/ngx-generic/services';
import {EntityService } from '@signature-it/ngx-entity/services';
import * as EntitySelectors from '@signature-it/ngx-entity/store/selectors';
import {ProductSolrDTO} from '@signature-it/ngx-catalogue/models';
import {ProductType} from '@signature-it/ngx-catalogue/classes';
import {SharedDataService, SolrProductService} from '@signature-it/ngx-catalogue/services';
import { ILanguage } from '@signature-it/ngx-generic/interfaces';
import * as EntityActions from '@signature-it/ngx-entity/store/actions';

declare var sessionStorage: any;

@Component({
    selector: 'product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    standalone: false
})
export class ProductCardComponent implements OnInit {
    @Input() productId:number;
    @Input() item: ProductSolrDTO;
    @Input() page: string;
    @Input() previewTemplateVar;
    @Input() mode: string = 'grid';
    @Output() onRemoveProduct: EventEmitter<any> = new EventEmitter<any>();
    imagePopularUrl: string = '';
    unCommerceApp: boolean = GenericConfig.unCommerceApp || false;
    commerceApp = GenericConfig.commerceApp == 'Add2CartOnly' ? true : false;
    compareProduct: boolean = GenericConfig.compareProduct == false ? false: true;
    hideProductImageBox: boolean = GenericConfig.hideProductImageBox || false;
    productPreviewVar = GenericConfig.productPreviewVar;
    public compare: any = {};
    public comparePage: boolean = false;
    protected compareData = JSON.parse(sessionStorage.getItem('compareData'));
    ProductType: any;
    previewVar: string = '';
    modeObj = {
        grid: 'boxPreviewVar',
        list: 'linePreviewVar'
    }
    templates$: Observable<any>;
    loadingTpl$: Observable<boolean>;
    loading = true;

    protected currLang: ILanguage;
    protected langSvc: LanguageService;
    protected solrProductSvc: SolrProductService;

    constructor(
        public restUrlsConfig: RestUrlsConfig,
        protected router: Router,
        public notifySvc: PageNotificationService,
        protected translateSvc: TranslateService,
        protected entityService: EntityService,
        public sharedData: SharedDataService,
        protected store$: Store<any>) {
        this.ProductType = ProductType;
        this.templates$ = this.store$.select(EntitySelectors.getPreviews);
        this.loadingTpl$ = this.store$.select(EntitySelectors.getIsLoadingPreviews);
        this.solrProductSvc = inject(SolrProductService);
        this.langSvc = inject(LanguageService);
        this.currLang = this.langSvc.getCurrentLanguage();
    }

    ngOnInit() {
        if(this.productId){
        this.store$.dispatch(EntityActions.getPreviews());
            this.solrProductSvc.getSolrByProductIds(this.currLang,[this.productId]).subscribe((productsId: ProductSolrDTO[]) => {
              productsId.map( product => {
                this.item = product;
              });
              this.init();
            });
        }
        else this.init();
    }


    init(){
	 this.loading = false;
         if (this.item && this.item['popular_s']) {
              let imagePopular = this.item['popular_s'];
              imagePopular = imagePopular.replace('.png', '');
              this.imagePopularUrl = `${this.restUrlsConfig.beURL}/images/Fittings/${GenericConfig.systemName}/field_images/popular/popular_${imagePopular}_Med.png`;
          }
          if (this.page == 'compare') {
              this.comparePage = true;
          }

          if (this.compareData && this.compareData.ids && this.compareData.ids.length > 0) {
              this.compare = {};
              for (let value of this.compareData.ids) {
                  this.compare[value] = true;
              }
          }

          if(this.previewTemplateVar  || this.item.boxPreviewVar || this.productPreviewVar?.grid) {
              this.previewVar = this.previewTemplateVar || this.item[this.modeObj[this.mode]] || this.productPreviewVar[this.mode];
          }

     }

    addToCompare(id) {
        this.compareData = JSON.parse(sessionStorage.getItem('compareData'));
        if (this.compareData && this.compareData.ids && this.compareData.ids.length > 2 && !this.compare[id]) {
            this.notifySvc.set(this.translateSvc.instant("can't compare more than 3 products"), 400).show();
        } else {
            if (this.compare[id] == null) {
                this.compare[id] = true;
            } else {
                this.compare[id] = !this.compare[id]
            }
            if (this.compare[id]) {
                if (this.compareData && this.compareData.ids) {

                    this.compareData.ids.push(id);
                    sessionStorage.setItem('compareData', JSON.stringify(this.compareData));
                } else {
                    this.compareData = {};
                    this.compareData.ids = [];
                    this.compareData.ids.push(id);
                    sessionStorage.setItem('compareData', JSON.stringify(this.compareData));
                }
            } else if (this.compare[id] === false) {
                let idIndex = this.compareData.ids.indexOf(id);
                if (this.compareData && this.compareData.ids && idIndex !== -1) {
                    this.compareData.ids.splice(idIndex, 1);
                    sessionStorage.setItem('compareData', JSON.stringify(this.compareData));
                }
            }
        }
    }

    removeFromCompare(id) {
        let idIndex = this.compareData.ids.indexOf(id);
        if (this.compareData && this.compareData.ids && idIndex !== -1) {
            this.compareData.ids.splice(idIndex, 1);
            sessionStorage.setItem('compareData', JSON.stringify(this.compareData));
        }
        window.location.reload();
    }
}
